// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2bs_a","content":"LoadingAlert_content__3hjeQ"};